import { FilterSection, L2FilterOption } from 'ace/filterSection';
import { CONSULTANT_ACHIEVEMENT_VALUES } from '~/modules/helpers/consultantAchievementFilterHelper';

export const parseFilterParam = function (param: unknown): string[] | undefined {
    const values = typeof param === 'string' ? [param] : Array.isArray(param) ? param : [];
    const parsed = values.flatMap((value) => (typeof value === 'string' ? value.split(';') : [])).filter(Boolean);
    return parsed.length ? parsed : undefined;
};

export const parseAchievementParam = (param: unknown): string[] | undefined => {
    const values = parseFilterParam(param)?.filter((value) => CONSULTANT_ACHIEVEMENT_VALUES.has(value));
    return values?.length ? [...new Set(values)] : undefined;
};

export const parseScalarFilterParam = function (param: unknown): string | undefined {
    if (typeof param === 'string') {
        return param;
    }
    return Array.isArray(param) ? param.find((value): value is string => typeof value === 'string') : undefined;
};

export const calculateSectionTotal = (options: L2FilterOption[]): number => {
    return options.reduce((sectionLength: number, option: L2FilterOption) => {
        if (option.isL2Filter) {
            sectionLength += option.options?.length || 0;
        } else {
            sectionLength += 1;
        }
        return sectionLength;
    }, 0);
};

export const totalFilterSearchResults = (filterSections: FilterSection[]) => {
    return filterSections.reduce((acc: number, section: FilterSection) => {
        const options = section.options as L2FilterOption[];
        const sectionTotal = calculateSectionTotal(options);
        acc += sectionTotal;
        return acc;
    }, 0);
};
